import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=301948a8&scoped=true&"
import script from "./BenefitsSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BenefitsSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=301948a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301948a8",
  null
  
)

export default component.exports